import { ReactNode } from 'react'
import { ReactComponent as BookingSvg } from 'src/assets/svg/booking-brand.svg'
import { ReactComponent as EarthSvg } from 'src/assets/svg/earth.svg'
import { ReactComponent as FacebookSvg } from 'src/assets/svg/facebook.svg'
import { ReactComponent as GoogleSvg } from 'src/assets/svg/google.svg'
import { ReactComponent as InstagramSvg } from 'src/assets/svg/instagram.svg'
import { ReactComponent as LinkedinSvg } from 'src/assets/svg/linkedin.svg'
// eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-imports
import { ReactComponent as NewsAndBlogsSvg } from 'src/assets/svg/New-and-Blogs.svg'
import { ReactComponent as RedditSvg } from 'src/assets/svg/reddit.svg'
import { ReactComponent as TiktokSvg } from 'src/assets/svg/tiktok.svg'
import { ReactComponent as TripadvisorSvg } from 'src/assets/svg/tripadvisor.svg'
import { ReactComponent as XSvg } from 'src/assets/svg/x.svg'
import { ReactComponent as YoutubeSvg } from 'src/assets/svg/youtube.svg'
import { ReactComponent as ThreadsSvg } from 'src/assets/svg/threads-square-svg.svg'
import { ReactComponent as ExpediaSvg } from 'src/assets/svg/expedia-brand.svg'
import { ReactComponent as WhatsappSvg } from 'src/assets/svg/whatsapp.svg'

export const SOCIAL_ICONS: Record<string, ReactNode> = {
  booking: <BookingSvg />,
  earth: <EarthSvg />,
  expedia: <ExpediaSvg />,
  facebook: <FacebookSvg />,
  'google reviews': <GoogleSvg />,
  instagram: <InstagramSvg />,
  linkedin: <LinkedinSvg />,
  'news & blogs': <NewsAndBlogsSvg />,
  reddit: <RedditSvg />,
  threads: <ThreadsSvg />,
  tiktok: <TiktokSvg />,
  tripadvisor: <TripadvisorSvg />,
  twitter: <XSvg />,
  whatsapp: <WhatsappSvg />,
  youtube: <YoutubeSvg />,
}
